import { render, staticRenderFns } from "./repayment.html?vue&type=template&id=21fd65d6&"
import script from "./repayment.js?vue&type=script&lang=js&"
export * from "./repayment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21fd65d6')) {
      api.createRecord('21fd65d6', component.options)
    } else {
      api.reload('21fd65d6', component.options)
    }
    module.hot.accept("./repayment.html?vue&type=template&id=21fd65d6&", function () {
      api.rerender('21fd65d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/easycash-indo/webview/help-center/repayment/repayment.vue"
export default component.exports